import { fetchDeleteUserRoleFailure, fetchDeleteUserRoleSuccess } from "./reducer";
import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchAllUserRoles } from "../thunk";
import { ROLE } from "../../constants/constants";

export const deleteUserRole = (name, setLoading, domain,setApiRefetching) => async (dispatch) => {
    try {
        setLoading(true);
        setApiRefetching(true);
        const response = await determineBaseUrlAndPerformApiCall(
            `${ROLE}/${name}`,
            'DELETE'
        );

        if (!response.error) {
            dispatch(fetchAllUserRoles(setLoading, domain));
            dispatch(fetchDeleteUserRoleSuccess(response));
            toast.success("User Role Deleted Successfully");
        } else {
            dispatch(fetchDeleteUserRoleFailure(response.error.message));
            toast.error(response.error.message);
        }
    } catch (errorResp) {
        console.error("Error in deleteUserRole method", errorResp);
    } finally {
        setLoading(false);
    }
};
